import { useRoute, useRouter } from 'vue-router'

const clearQueryByParams = (params: string[]) => {
  const router = useRouter()
  const route = useRoute()
  const newQuery = { ...route.query }
  let isDiff = false

  params.forEach(param => {
    if (!isDiff) {
      isDiff = !!newQuery[param]
    }
    delete newQuery[param]
  })

  if (!isDiff) return

  router.replace({ query: newQuery })
}

export default clearQueryByParams
